import BroadcastsListPage from "pages/broadcasts/BroadcastsListPage";
import BroadcastEditPage from "pages/broadcasts/BroadcastEditPage";
import { Route, Switch } from "react-router-dom";

const BookingRoutes = () => (
    <Switch>
        <Route exact path="/broadcasts" component={BroadcastsListPage} />
        <Route exact path="/broadcasts/create" component={BroadcastEditPage} />
    </Switch>
);

export default BookingRoutes;
